module.exports = __webpack_public_path__ + "static/media/MACS_logo.723e85c4.svg";